export interface ResponseList<T> {
  dataList: T[];
  pagination: Pagination;
}

export interface Page {
  total?: number;
  offset?: number;
  limit?: number;
}

export interface SearchForm {
  category?: string;
  filter?: string;
  status?: string;
}

export interface SearchParams {
  firstParam?: string;
  secondParam?: string;
  thirdParam?: string;
}

export interface SearchDiscountForm {
  filter?: string;
  type?: DiscountType;
  appliedFrom?: DiscountAppliedFrom;
}

export interface TableColumn {
  field: string;
  header: string;
}

export interface ResponseDelete {
  id: number;
  deleted: boolean;
}

export interface Pagination {
  offset: number;
  limit: number;
  total: number;
}

export interface DataTableInfo<T> {
  dataList: ResponseList<T>;
  currentPage: number;
  totalPage: number;
}

export interface Member {
  id?: number;
  parkingLotId?: number;
  name: string;
  title: string;
  email: string;
  phoneNumber: string;
  status: string;
  createdDate?: string;
  updatedDate?: string;
  remark?: string;
  address?: Address;
  remainingMonthlyBookingQuota?: number;
  parkingLotSubscribers?: Subscriber[];
  parkingLotCards?: Card[];
  parkingLotGroupSpace?: ParkingLotGroupSpace;
  roleMemberId?: number;
  roleMember?: RoleMember;
}

export interface Address {
  number: string;
  buildingName: string;
  street: string;
  subdistrict: string;
  district: string;
  province: string;
  country: string;
  zipCode: string;
}

export interface Subscriber {
  id: number;
  parkingLotId: number;
  parkingLotMemberId?: number;
  status: string;
  title: string;
  name: string;
  email: string;
  phoneNumber: string;
  car?: AvailableCar;
  carBrand?: string;
  carModel?: string;
  carType?: string;
  licensePlate?: string;
  licensePlateNumber: string;
  licensePlateLetter: string;
  licensePlateProvince: string;
  startDate: string;
  validThrough: string;
  startTime: string;
  endTime: string;
  canConcurrentParking: boolean;
  remark: string;
  accessibleLift: boolean;
  carSpecification?: AvailableCar;
  parkingLotCard?: Card;
  isChecked?: boolean;
  createdDate: string;
  updatedDate: string;
}

export interface Card {
  id?: number;
  parkingLotId: number;
  parkingLotMemberId?: number;
  cardRFId: string;
  cardRefId: string;
  status: string;
  isChecked?: boolean;
  expiredDate: string;
  updatedDate: string;
  createdDate: string;
}

export interface TableConfig {
  field: string;
  title: string;
  type?: string;
  permission?: string;

  text?(row: any): any;

  class?(row: any): any;
}

export interface Province {
  pid: string;
  name: string;
}

export interface PlateFormValue {
  plateLetter: string;
  plateNumber: string;
  plateProvince: string;
  availableCarSelected: AvailableCar;
  status: string;
  startDate: string;
  validThrough: string;
  startTime: string;
  endTime: string;
}

export interface CardFormValue {
  cardRefId: string;
  cardRFId: string;
  status: string;
  card?: Card;
}

export interface ParkingLotCard {
  id?: number;
  parkingLotId: number;
  cardRefId: string;
  cardRFId: string;
  status: string;
  createdDate?: string;
  updatedDate?: string;
}

export interface AvailableCar {
  checked?: boolean;
  id?: number;
  type: string;
  brand: string;
  model: string;
  width: number;
  length: number;
  height: number;
  heightAntenna?: number;
  weight: number;
  edited?: boolean;
  updatedDate?: Date;
  createdDate?: Date;
}

export interface AvailableCarFormGroup {
  car: AvailableCar,
  checked: boolean,
  isEdit: boolean
  carDetail: AvailableCar
}

export interface ParkingLotLift {
  id?: number;
  parkingLotId: number;
  width: number;
  length: number;
  height: number;
  weight: number;
  enabled: boolean;
  updatedDate?: Date;
  createdDate?: Date;
}

export interface ParkingLotGroupSpace {
  id: number,
  blockIdText: string,
  groupName?: string,
  priority?: number,
  monthlyBookingQuota?: number,
  checked?: boolean,
}

export interface RoleMember {
  id: number,
  parkingLotId: number,
  roleMemberName: string,
  roleMemberCode: string,
  freeOfChargeStartTime?: Date,
  freeOfChargeEndTime?: Date,
  freeOfChargeDuration?: number,
  rates: string,
  chargeType: ChargeType,
  maxMemberAmount: number,
  enablePrivateZone: boolean,
  createdDate: Date,
  updatedDate: Date
}

export enum ChargeType {
  CHARGE = 'CHARGE',
  FREE = 'FREE',
  CHARGE_LATER = 'CHARGE_LATER'
}

export enum ParkingInventoryLocation {
  ENTRANCE = 'ENTRANCE',
  ZONE_ENTRANCE = 'ZONE_ENTRANCE',
  EXIT = 'EXIT'
}

export enum ParkingInventoryType {
  BARRIER = 'BARRIER',
  LICENSE_PLATE_CAMERA = 'LICENSE_PLATE_CAMERA',
  DRIVER_CAMERA = 'DRIVER_CAMERA',
  PRINTER = 'PRINTER',
  DESKTOP = 'DESKTOP',
  TABLET = 'TABLET'
}

export enum ParkingInventoryStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ParkingMemberStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum RoleMemberSiph {
  DOCTOR = 'แพทย์ประจำ',
  DOCTOR_CONSULT = 'แพทย์ที่ปรึกษา',
  MUSEUM_STAFF = 'บุคลากรพิพิธภัณฑ์',
  SIPH_STAFF = 'บุคลากรศิริราช',
  NIGHTTIME_STAFF = 'บุคลากรกะดึก',
  AUTHORIZED_STAFF = 'บุคลากรที่ได้รับสิทธิ์'


}

export enum DiscountType {
  HOUR = 'HOUR',
  PRICE = 'PRICE',
  FREE = 'FREE',
}

export enum DiscountStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED'
}

export enum DiscountAppliedFrom {
  ADMIN = 'ADMIN',
  CUSTOMER = 'CUSTOMER'
}

export enum SiphRoleMember {
  DOCTOR = 'DOCTOR',
  DOCTOR_CONSULT = 'DOCTOR_CONSULT',
  MUSEUM_STAFF = 'MUSEUM_STAFF',
  SIPH_STAFF = 'SIPH_STAFF',
  NIGHTTIME_STAFF = 'NIGHTTIME_STAFF',
  AUTHORIZED_STAFF = 'AUTHORIZED_STAFF'
}

export interface ParkingInventory {
  id?: number,
  parkingLotId?: number,
  name: string,
  type: ParkingInventoryType,
  status: ParkingInventoryStatus,
  location?: ParkingInventoryLocation,
  ipAddress?: string,
  model?: string,
  serialNumber?: string,
  createdDate?: Date,
  updatedDate?: Date
}

export interface Discount {
  id: number,
  parkingLotId?: number,
  parkingLotUsageId?: number,
  slipCode?: string, // ถ้าใช้ slip_code จะทำให้ licensePlateLetter, licensePlateNumber, licensePlateProvince เป็น NULL
  licensePlateLetter?: string,
  licensePlateNumber?: string,
  licensePlateProvince?: string,
  name: string,
  description?: string,
  code: string,
  amount: number,
  type: DiscountType,
  status: DiscountStatus,
  appliedFrom: DiscountAppliedFrom,
  appliedChannel: string,
  appliedUser?: string,
  appliedDate: string,
  startDate?: Date,
  expiryDate?: Date,
  isFreeOfCharge?: boolean,
  timeLimit?: number,
  isUnlimited?: boolean,
  createdDate: Date,
  updatedDate: Date
}

export enum CouponType {
  HOUR = 'HOUR',
  PRICE = 'PRICE',
  FREE = 'FREE'
}

export enum CouponStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED'
}

export interface Coupon {
  id: number,
  code: string,
  parkingLotId?: number,
  amount: number,
  type: CouponType,
  status: CouponStatus,
  startDate?: string,
  expiryDate?: string,
  isFreeOfCharge: boolean,
  name: string,
  description?: string,
  timeLimit?: number,
  isUnlimited: boolean,
  createdDate?: string,
  updatedDate?: string
}

export enum SiPHUserRoles {
  ROLE_SIPH_ADMIN_BU = 'ROLE_SIPH_ADMIN_BU', // All Free (0 THB)
  ROLE_SIPH_ADMIN_CALCULATE = 'ROLE_SIPH_ADMIN_CALCULATE', // 2,4,8 Hrs (มอบส่วนลดจากการคำนวณค่าใช้จ่าย แล้วแปลงเป็นชั่วโมง)
  ROLE_SIPH_ADMIN_FIN = 'ROLE_SIPH_ADMIN_FIN', // 2,4,8,24 Hrs and All Free (0 THB)
  ROLE_SIPH_STAFF_B1 = 'ROLE_SIPH_STAFF_B1', // 2,4, All Free Hrs
  ROLE_SIPH_SUPERADMIN = 'ROLE_SIPH_SUPERADMIN' // 2,4,8,24 Hrs and All Free (0 THB)
}

export enum JOWITUserRoles {
  ROLE_JOWIT_ADMIN_ORGANIZATION = 'ROLE_JOWIT_ADMIN_ORGANIZATION'
}

export interface UserInfo {
  id: number,
  email: string,
  name: string,
  phoneNumber: number,
  roles: string[],
  acceptedTerm: boolean,
  enabled: boolean,
  organizationId?: number,
  menus?: string[],
  parkingLots?: number
}

export enum BillType {
  MEDICINE = 'MEDICINE', // ค่ายา
  SERVICE = 'SERVICE', // ค่าบริการ
}

export interface ApplyCoupon {
  type: DiscountType,
  amount: number,
  billFee?: number,
  billType?: BillType,
}

export interface ParkingLotUsage {
  id: number,
  parkingLotId: number,
  usageType: string,
  usageStatus: string,
  checkedIn: string,
  checkedOut: string,
  licensePlateLetter: string,
  licensePlateNumber: string,
  licensePlateProvince: string,
  parkingType: string,
  totalTimeSpent: number,
  billingTimeSpent: number,
  subtotal: number,
  discount: number,
  discountType: DiscountType,
  total: number,
  outstandingBalance: number,
  outstandingBalancePeriod: number,
  enableCardPayment: boolean,
  locked: boolean,
  createdDate: string,
  updatedDate: string,
  member: boolean,
  paid: boolean,
  cardLost: boolean,
  phoneNumber: string,
  slipNumber: string
}


export interface ParkingLotUsageQuery {
  licensePlateLetter?: string,
  licensePlateNumber?: string,
  licensePlateProvince?: string,
  phoneNumber?: string,
  slipNumber?: string
}

export interface SubscriberVirtualCard {
  id: number,
  title: string,
  name: string,
  phoneNumber: string,
  email?: string,
  startDate: string
  expiryDate: string
  rfid: string
  createdDate?: string
  updatedDate?: string
}

export interface ParkingLotMemberQuery {
  licensePlateLetter?: string,
  licensePlateNumber?: string,
  licensePlateProvince?: string
}

export interface TemporaryRateData {
  id?: number,
  rates,
  licenseType,
  description,
  freePeriod ,
  flatRate,
  flatRatePeriod,
  haveHourlyRate,
  haveFlatRate,
  min,
  max
}




// WEBPACK FOOTER //
// ./src/app/helpers/interfaces.ts